import { render, staticRenderFns } from "./Cb4xModalContent.vue?vue&type=template&id=b04b2c0e"
import script from "./Cb4xModalContent.vue?vue&type=script&lang=js"
export * from "./Cb4xModalContent.vue?vue&type=script&lang=js"
import style0 from "./Cb4xModalContent.vue?vue&type=style&index=0&id=b04b2c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports